/* @flow */

import * as React from 'react';

import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateEmail as UpdateEmailMutation,
    UpdateEmailVariables as UpdateEmailMutationVariables,
    RetryFailedEmail as RetryFailedEmailMutation,
    RetryFailedEmailVariables as RetryFailedEmailMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_EMAIL from '../../../email/mailbox/graphql/mutations/update-email.graphql';
import RETRY_FAILED_EMAIL from '../../../email/mailbox/graphql/mutations/retry-failed-email.graphql';

type Props = {
    children: ({
        updateEmail: (emailId: string, shouldShare: boolean) => Promise<*>,
        retryFailedEmail: (emailId: string) => Promise<*>,
    }) => React.Node,
};

export function EmailMutationWrapper(props: Props) {
    const [updateEmail] = useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(
        UPDATE_EMAIL
    );

    const [retryFailedEmail] = useMutation<
        RetryFailedEmailMutation,
        RetryFailedEmailMutationVariables
    >(RETRY_FAILED_EMAIL);

    return props.children({
        updateEmail: (emailId: string, shouldShare: boolean) => {
            return updateEmail({
                variables: {
                    payload: {
                        emailId,
                        shouldShare,
                    },
                },
            }).then(
                (mutationResults) =>
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.emailShareAndCreateContacts &&
                    mutationResults.data.emailShareAndCreateContacts.email
            );
        },
        retryFailedEmail: (emailId: string) => {
            return retryFailedEmail({
                variables: {
                    payload: {
                        emailId,
                    },
                },
            }).then(
                (mutationResults) =>
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.failedEmailRetry &&
                    mutationResults.data.failedEmailRetry.email
            );
        },
    });
}
